/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Explore_Alternatives_DetailInputs */

const en_common_header_explore_alternatives_detail = /** @type {(inputs: Common_Header_Explore_Alternatives_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare and switch`)
};

const zh_common_header_explore_alternatives_detail = /** @type {(inputs: Common_Header_Explore_Alternatives_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对比后切换`)
};

/**
* | output |
* | --- |
* | "Compare and switch" |
*
* @param {Common_Header_Explore_Alternatives_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_explore_alternatives_detail = /** @type {((inputs?: Common_Header_Explore_Alternatives_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Explore_Alternatives_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_explore_alternatives_detail(inputs)
	return zh_common_header_explore_alternatives_detail(inputs)
});
export { common_header_explore_alternatives_detail as "common.header.explore.alternatives.detail" }